import api from "./api";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import * as eventTypes from "./eventTypes";
import * as actionTypes from "./actionTypes";

export function loadKpiIndicators(documentId, siteId) {
  return async (dispatch, getState) => {
    let kpiIndicatorsState = getState().facilities.facilityKpiIndicators[documentId];

    let shouldCallApi = !kpiIndicatorsState || (!kpiIndicatorsState.loaded && !kpiIndicatorsState.loading);
    if (!shouldCallApi) return;

    try {
      dispatch({ type: actionTypes.LOAD_FACILITY_KPI_INDICATORS_STARTED, key: documentId });

      const response = await dispatch(sendHttpRequest(api.getKpiIndicators(documentId, siteId)));

      dispatch({
        type: actionTypes.LOAD_FACILITY_KPI_INDICATORS_SUCCEEDED,
        key: documentId,
        payload: response
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_FACILITY_KPI_INDICATORS_FAILED, key: documentId, error });
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function saveKpiIndicators(documentId, siteId, kpiIndicators, callback = () => {}) {
  return async dispatch => {
    const payload = kpiIndicators.map(x => {
      return {
        leasingFacilitiesXItemTypeId: x.leasingFacilitiesXItemTypeId,
        indicatorId: x.indicatorId,
        indicatorValue: x.indicatorValue,
        itemTypeId: x.itemTypeId
      };
    });
    dispatch(
      sendHttpCommandAndWaitForEvent(api.saveKpiIndicators(documentId, siteId, payload), "SaveFacilityKpiIndicators", [
        eventTypes.FACILITY_ITEM_TYPE_KPIS_SAVED
      ])
    )
      .then(event => {
        if (event.ok) {
          dispatch(loadKpiIndicators(documentId, siteId));
          callback(event.ok);
        } else {
          callback();
        }
      })
      .catch(error => {
        dispatch(showError(error.message, error.correlationId));
        callback();
      });
  };
}
